import {
  Bars2Icon,
  BellAlertIcon,
  ChevronDoubleDownIcon,
  ChevronDoubleUpIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/24/outline';

import { RiskSeverity } from '@/types';
import { cn } from '@/utils/classname';

export const getRiskSeverityIcon = (
  severity: RiskSeverity,
  className = 'size-5'
) => {
  switch (severity) {
    case RiskSeverity.Critical:
      return (
        <ChevronDoubleUpIcon
          className={cn('text-chariot-stroke-critical', className)}
        />
      );
    case RiskSeverity.High:
      return (
        <ChevronUpIcon className={cn('text-chariot-stroke-high', className)} />
      );
    case RiskSeverity.Medium:
      return (
        <Bars2Icon className={cn('text-chariot-stroke-medium', className)} />
      );
    case RiskSeverity.Low:
      return (
        <ChevronDownIcon className={cn('text-chariot-stroke-low', className)} />
      );
    case RiskSeverity.Exposure:
      return <BellAlertIcon className={'size-5 shrink-0'} />;
    case RiskSeverity.Info:
    default:
      return (
        <ChevronDoubleDownIcon
          className={cn('border-chariot-stroke', className)}
        />
      );
  }
};
